import React from 'react';
import { ListItem } from '@tmapy/style-guide';

import './BoxItem.scss';

type BoxItemProps = {
  stateColorClassName: string;
  stateTooltip: string;
  children: React.ReactNode;
};

export const BoxItem: React.FC<BoxItemProps> = ({
  stateColorClassName,
  stateTooltip,
  children,
}) => {
  return (
    <ListItem>
      <article className={`dmx-boxItem sg-a-d-f ${stateColorClassName}`} title={stateTooltip}>
        <div className='sg-a-f-a sg-a-pt-1 sg-a-pl-2 sg-a-mw-0'>{children}</div>
      </article>
    </ListItem>
  );
};
